import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap'
import {toastr} from 'react-redux-toastr'
import {SubmissionError} from 'redux-form'

import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import api from '../../../../api.js'

import Modal from '../../../../shared/components//Modals/Modal.jsx'
import OfferAnswerDenialForm, {name as formName} from '../../Forms/OfferAnswerDenialForm/OfferAnswerDenialForm.jsx'
import SubmitButton from '../../Forms/OfferAnswerDenialForm/SubmitButton.jsx'

export default class OfferAnswerDenialModal extends Modal {
  submit = async(_data) => {
    const data = {
      denialMotive: parseInt(_data.denial_motive, 10),
      offerAnswer: this.props.answer.id,
      offer: this.props.offer.id
    }
    try {
      return await api.offers.answers.edit(data)
    } catch(e) {
      console.warn(e)
      throw new SubmissionError(e)
    }
  }

  onFormSuccess = (response) => {
    toastr.success('Votre réponse à la candidature a bien été envoyée.')
    if(this.props.onClose) {
      this.props.onClose({
        answer: response.data,
        offset: this.props.offset,
      })
    }
    this.props.closeModal()
  }

  onSubmitFail = (response) => {
    createOnSubmitFailHandler(formName)

    if(response.data) {
      for (let i=0; i<response.data.errors.length; i++) {
        toastr.error(response.data.errors[i].message)
      }
    }
  }

  render() {
    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} size="lg">
        <ModalHeader toggle={this.props.closeModal}>Sélectionner une réponse automatique</ModalHeader>
        <ModalBody>
          <OfferAnswerDenialForm
            initialValues={{denial_motive: 0}}
            onSubmit={this.submit}
            onSubmitSuccess={this.onFormSuccess}
            onSubmitFail={this.onSubmitFail}
          />
          <SubmitButton className="btn btn-primary my-3">
            Envoyer
          </SubmitButton>
        </ModalBody>
      </BootstrapModal>
    )
  }
}